import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
interface Punctuality {
  route: string;
  time: number;
}
export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const [dataChartTime, setDataChartTime] = useState<string[]>([]);
  const [max, setMax] = useState<string>("");

  useEffect(() => {
    const etaName: string[] = [],
      etaTime: string[] = [],
      etaQtd: number[] = [];
    const sizes = getSizesComponent({ id: "chart-punctual-super-delayed" });
    data.eta.map((route: Punctuality) => {
      etaQtd.push(route.time);
      etaName.push("Rota " + route.route);
      if (route.time % 60 !== 0 && route.time > 60) {
        const hours = Math.floor(route.time / 60);
        const minutes = route.time % 60;
        etaTime.push(hours + "h" + minutes + "m");
      } else if (route.time >= 60) {
        const hours = Math.floor(route.time / 60);
        etaTime.push(hours + "h");
      } else {
        etaTime.push(route.time + "m");
      }
    });
    if (etaQtd && etaQtd.length !== 0) {
      const fakesCol = Math.floor(sizes.height / etaQtd.length / 230);
      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          etaQtd.push(0);
        }
      }
    }
    setLabels(etaName);
    setDataChart(etaQtd);
    setDataChartTime(etaTime);

    if (data.max % 60 !== 0 && data.max > 60) {
      const hours = Math.floor(data.max / 60);
      const minutes = data.max % 60;
      setMax(hours + "h" + minutes + "m");
    } else if (data.max >= 60) {
      const hours = Math.floor(data.max / 60);
      setMax(hours + "h");
    } else {
      setMax(data.max + "m");
    }
  }, [data]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-punctual-super-delayed" });

    if (sizes.width < 345) {
      setFontSize({ id: "chart-punctual-super-delayed", width: sizes.width });
    }
    if (dataChart && dataChart.length > 4) {
      if (sizes.height > dataChart.length * 50) {
        setHeightChart(sizes.height - 40);
      } else {
        setHeightChart(dataChart.length * 35);
      }
    } else {
      setHeightChart(sizes.height - 40);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [dataChart]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: ["#fd6763"],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        if (labels[opt.dataPointIndex]) {
          return (
            labels[opt.dataPointIndex] +
            ":  " +
            dataChartTime[opt.dataPointIndex]
          );
        }
        return "";
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
      labels: {
        show: false,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };
  const series = [
    {
      data: dataChart,
    },
  ];

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Muito atrasado: ${data.count} rotas com mais de ${max} de atraso`}
        clickable={componentProperty({
          id: "chartPunctualSuperDelayed",
          property: "redirect",
        })}
        id="chart-punctual-super-delayed"
      />
      <div
        id={
          dataChart &&
          (dataChart.length <= 4 ||
            getSizesComponent({ id: "chart-punctual-super-delayed" }).height >
              dataChart.length * 50)
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
